var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.031 10.0306L12.531 17.5306C12.4614 17.6003 12.3787 17.6556 12.2876 17.6933C12.1966 17.7311 12.099 17.7505 12.0004 17.7505C11.9019 17.7505 11.8043 17.7311 11.7132 17.6933C11.6222 17.6556 11.5394 17.6003 11.4698 17.5306L3.96979 10.0306C3.82906 9.88982 3.75 9.69895 3.75 9.49993C3.75 9.30091 3.82906 9.11003 3.96979 8.9693C4.11052 8.82857 4.30139 8.74951 4.50042 8.74951C4.69944 8.74951 4.89031 8.82857 5.03104 8.9693L12.0004 15.9396L18.9698 8.9693C19.0395 8.89962 19.1222 8.84435 19.2132 8.80663C19.3043 8.76892 19.4019 8.74951 19.5004 8.74951C19.599 8.74951 19.6965 8.76892 19.7876 8.80663C19.8786 8.84435 19.9614 8.89962 20.031 8.9693C20.1007 9.03899 20.156 9.12171 20.1937 9.21276C20.2314 9.3038 20.2508 9.40138 20.2508 9.49993C20.2508 9.59847 20.2314 9.69606 20.1937 9.7871C20.156 9.87815 20.1007 9.96087 20.031 10.0306Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.bbbe3417b70385970ba820c9931fd257.svg";
export { ForwardRef as ReactComponent };